"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _settings = require("@izzistock/settings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getColorStyle = function getColorStyle(color) {
  switch (color) {
    case 'primary':
      return {
        color: _settings.colors.textPrimary
      };

    case 'secondary':
      return {
        color: _settings.colors.textSecondary
      };

    default:
      return {
        color: _settings.colors.textDefault
      };
  }
};

var _default = function _default(_ref) {
  var color = _ref.color,
      style = _ref.style,
      children = _ref.children,
      bold = _ref.bold,
      props = _objectWithoutProperties(_ref, ["color", "style", "children", "bold"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNative.Text, _extends({
    style: [getColorStyle(color), {
      fontFamily: 'Open Sans',
      fontWeight: bold ? "bold" : '100'
    }, style]
  }, props), children);
};

exports["default"] = _default;